import { RequestStatus } from '@atlassian/mpac-api-client';
import { DialogState } from '../AppRequestDialog.types';
export function getDialogState(appRequestBaseData) {
  var _result$appRequestSta, _result$appRequestSta2;
  const {
    pending,
    result
  } = appRequestBaseData;
  if (pending) {
    return DialogState.LOADING;
  } else if (result.appInstallStatus.installationId) {
    return DialogState.INSTALLED;
  } else if (((_result$appRequestSta = result.appRequestStatus) === null || _result$appRequestSta === void 0 ? void 0 : _result$appRequestSta.status) === RequestStatus.REJECTED) {
    return DialogState.REJECTED;
  } else if (((_result$appRequestSta2 = result.appRequestStatus) === null || _result$appRequestSta2 === void 0 ? void 0 : _result$appRequestSta2.status) === RequestStatus.OPEN) {
    return DialogState.REQUESTED;
  } else if (!result.appRequestStatus && result.appInstallStatus.status === 'NOT_FOUND') {
    return DialogState.REQUESTABLE;
  }
  return DialogState.ERROR;
}